import { HeadSchemaScript } from './HeadSchemaScript';

type VideoSchemaProps = {
  id: string;
  name: string;
  description: string;
  duration: string;
  uploadDate: string;
  thumbnailUrl: string;
  contentUrl: string;
  embedUrl: string;
  transcript?: string;
  potentialAction?: object;
};

export const VideoSchema = ({
  id,
  name,
  description,
  duration,
  uploadDate,
  thumbnailUrl,
  contentUrl,
  embedUrl,
  transcript,
}: VideoSchemaProps) => {
  const schemaId = `video-${id}-jsonld`;

  const schemaData = {
    '@context': 'https://schema.org/',
    '@type': 'VideoObject',
    name: name,
    description: description,
    duration: duration,
    uploadDate: uploadDate,
    thumbnailUrl: thumbnailUrl,
    contentUrl: contentUrl,
    embedUrl: embedUrl,
    transcript: transcript,
  };

  return (
    <HeadSchemaScript
      id={`add-${schemaId}`}
      schemaId={schemaId}
      json={schemaData}
    />
  );
};

export default VideoSchema;
